export const SET_CONTRACTORS = 'SET_CONTRACTORS';
export const SET_SIMPLE_CONTRACTORS = 'SET_SIMPLE_CONTRACTORS';
export const SET_REQUESTS = 'SET_REQUESTS';
export const SET_CONTRACTOR = 'SET_CONTRACTOR';
export const SET_ORDERS = 'SET_ORDERS';
export const SET_TRANSACTIONS = 'SET_TRANSACTIONS';
export const SET_DISABLED_CONTRACTORS = 'SET_DISABLED_CONTRACTORS';

export const SET_CONTRACTOR_BLOCKING = 'SET_CONTRACTOR_BLOCKING';
export const SET_CONTRACTOR_ORDERS = 'SET_CONTRACTOR_ORDERS';
export const SET_CONTRACTOR_TRANSACTIONS = 'SET_CONTRACTOR_TRANSACTIONS';

export const SET_CONTRACTOR_BALANCE_BY_ID = 'SET_CONTRACTOR_BALANCE_BY_ID';
